<template src="./AddMoreDays.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import BaseSolutionComponent from "../BaseSolutionComponent";
import BaseButton from "@/components/BaseButton";
import { solutionModule } from "@/store/modules/solution";
import { SolutionActions } from "@/store/modules/solution/actions";
import { AddMoreDaysDTO } from "@/models/solution/AddMoreDaysDTO";
import dateFormat from "dateformat";
import { VForm } from "vuetify/lib/components/VForm/VForm";

export default defineComponent({
    extends: BaseSolutionComponent,
    components: { BaseButton },
    data() {
        return {
            days: 0,
            reason: "",
            nextDate: null as string | null,
            disabled: false,
            showSkeleton: true
        };
    },
    methods: {
        ...solutionModule.mapActions({
            addMoreDays: SolutionActions.AddMoreDays
        }),
        async submit(): Promise<void> {
            const result = await (this.$refs.form as VForm).validate();
            if (result.valid) {
                await this.setMoreDays(this.days, this.reason);
            }
        },
        async setMoreDays(days: number, reason?: string) {
            if (this.tokenData) {
                const date = await this.addMoreDays({
                    token: this.tokenData.token,
                    days,
                    reason
                } as AddMoreDaysDTO);
                this.nextDate = dateFormat(date, "dd.mm.yyyy");
            }
        }
    },
    computed: {
        daysParam(): number | null {
            const days = this.$route.query.days;
            if (days && !isNaN(Number(days))) {
                return Number(days);
            }
            return null;
        }
    },
    created() {
        if (this.tokenData) {
            this.getSolutionCase(this.tokenData).then((result) => {
                if (!result) {
                    this.disabled = true;
                }
                if (this.daysParam) {
                    this.setMoreDays(this.daysParam);
                } else {
                    this.showSkeleton = false;
                }
            });
        } else {
            this.showError("Invalid Token");
        }
    }
});
</script>
